/**
 * Shared Tizen on-screen log helper.
 *
 * When REACT_APP_TIZEN_ONSCREEN_LOG=true, every tizenLog() call appends a line
 * to window.__tizenLogLines (read by TizenDebugOverlay) AND writes to console.
 *
 * In production (flag=false) the calls compile to near-zero overhead.
 */

export const isOnScreenLogEnabled =
  process.env.REACT_APP_TIZEN_ONSCREEN_LOG === 'true' ||
  process.env.REACT_APP_HTTP_STREAM_LOG === 'true';

const ENABLED = isOnScreenLogEnabled;

if (ENABLED && typeof window !== 'undefined') {
  window.__tizenLogLines = window.__tizenLogLines || [];
}

/**
 * @param {'INFO'|'WARN'|'ERROR'} level
 * @param {string} tag  - short prefix, e.g. '[Device]', '[Factory]', '[TEP Player]'
 * @param {string} msg  - message (keep short — screen real-estate is limited)
 */
export function tizenLog(level, tag, msg) {
  if (!ENABLED) return;

  const ts = new Date().toISOString().slice(11, 23); // HH:MM:SS.mmm
  const line = `${ts} ${level} ${tag} ${msg}`;

  // Push to overlay ring-buffer (keep last 30 lines)
  if (typeof window !== 'undefined') {
    window.__tizenLogLines = window.__tizenLogLines || [];
    window.__tizenLogLines.push(line);
    if (window.__tizenLogLines.length > 30) {
      window.__tizenLogLines.shift();
    }
    // Notify overlay component to re-render
    if (typeof window.__tizenLogRefresh === 'function') {
      window.__tizenLogRefresh();
    }
  }

  // Also write to browser console
  if (level === 'ERROR') console.error(line);
  else if (level === 'WARN') console.warn(line);
  else console.log(line);
}

export const tLog   = (tag, msg) => tizenLog('INFO',  tag, msg);
export const tWarn  = (tag, msg) => tizenLog('WARN',  tag, msg);
export const tError = (tag, msg) => tizenLog('ERROR', tag, msg);
